import { isEmpty } from 'lodash';
import { filterPlacesIds } from '../../helpers/filterPlacesIds/filterPlacesIds';
import getPlaces from './getPlaces';
const getPageLocationLabels = async (locations, bffUri) => {
    const placeIds = filterPlacesIds(locations);
    const labels = await getPlaces(placeIds, bffUri);
    // ensure order remains the same
    // filter and ensure type safeness by using type predicates: https://www.typescriptlang.org/docs/handbook/advanced-types.html#using-type-predicates
    const locationsLabels = placeIds.map((id) => labels[id]).filter((label) => Boolean(label));
    return locationsLabels.length > 0 ? locationsLabels : [''];
};
export const getPageDistributionType = (distributionTypes) => {
    if (isEmpty(distributionTypes) || isEmpty(distributionTypes[0]))
        return '';
    if (distributionTypes[0].includes('Auction'))
        return 'Buy';
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- the first check ensures that the first element is not empty
    return distributionTypes[0];
};
export const fetchPageData = async ({ searchModel, bffUri }) => {
    const { distributionTypes, estateTypes, locations } = searchModel;
    // FIXME: ensure working for weird SEO cases (no estate type, no distribution type)
    const locationLabels = await getPageLocationLabels(locations, bffUri);
    return {
        distributionType: getPageDistributionType(distributionTypes).toLowerCase(),
        estateType: `${estateTypes?.[0]}`.toLowerCase(),
        locations: locationLabels,
    };
};
